export default [
  {
    name: 'Eventos',
    icon: 'mdi-calendar-blank',
    path: '/admin/calendar',
    component: () => import(/* webpackChunkName: "admin-calendar" */ './views/AdminCalendar'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      adminBadge: true,
      tooltip: null,

      adminBadgeContent: 'unreadedUserEvent',
      adminBadgeChecker: 'userEventsReady',
    },
  },
];
